import React, { useState } from "react"
import styled from "styled-components"
import { clipboardCopy } from "../InteractiveTerminal/clipboard-copy"

const HEADER_HEIGHT = "47px"

const CopyIcon = () => {
  return (
    <svg height="12px" width="12px">
      <use href="#icon-copy"></use>
      <symbol id="icon-copy" viewBox="0 0 12 12" fill="none">
        <path
          d="M7.66667 8.64706V10.6078C7.66667 10.8244 7.49109 11 7.27451 11H1.39216C1.17557 11 1 10.8244 1 10.6078L1 4.72549C1 4.50891 1.17557 4.33333 1.39216 4.33333H3.35294"
          stroke="#21313C"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <rect
          x="4.3335"
          y="7.6665"
          width="6.66667"
          height="6.66667"
          rx="1"
          transform="rotate(-90 4.3335 7.6665)"
          stroke="#21313C"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></rect>
      </symbol>
      <symbol id="icon-copy" viewBox="0 0 12 12" fill="none">
        <path
          d="M7.66667 8.64706V10.6078C7.66667 10.8244 7.49109 11 7.27451 11H1.39216C1.17557 11 1 10.8244 1 10.6078L1 4.72549C1 4.50891 1.17557 4.33333 1.39216 4.33333H3.35294"
          stroke="#21313C"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <rect
          x="4.3335"
          y="7.6665"
          width="6.66667"
          height="6.66667"
          rx="1"
          transform="rotate(-90 4.3335 7.6665)"
          stroke="#21313C"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></rect>
      </symbol>
      <symbol id="icon-copy" viewBox="0 0 12 12" fill="none">
        <path
          d="M7.66667 8.64706V10.6078C7.66667 10.8244 7.49109 11 7.27451 11H1.39216C1.17557 11 1 10.8244 1 10.6078L1 4.72549C1 4.50891 1.17557 4.33333 1.39216 4.33333H3.35294"
          stroke="#21313C"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <rect
          x="4.3335"
          y="7.6665"
          width="6.66667"
          height="6.66667"
          rx="1"
          transform="rotate(-90 4.3335 7.6665)"
          stroke="#21313C"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></rect>
      </symbol>
    </svg>
  )
}

const Content = styled.div`
  height: calc(100% - 30px);

  pre {
    height: calc(100% - 30px);
    max-height: 304px;
    overflow-y: auto;

    code {
      height: calc(100% - 30px);
      overflow-x: auto;
    }

    .line-number > span {
      color: #9fa1a2;
    }
  }
`

const TerminalWindowWrapper = styled.div`
  @media (max-width: 600px) {
    width: 100%;
  }

  .snippet-box {
    @media (max-width: 600px) {
      position: static !important;
    }
  }
  .hide-lt-600 {
    @media (max-width: 600px) {
      display: none;
    }
  }
`

export const TerminalWindow = ({
  children,
  textSide = "Left",
  width = "565",
  height = "330",
  theme = 0,
  languages = [],
  language = {},
  changeSelectedLanguage = () => {},
  codeSnippet = "",
}) => {
  const [copied, setCopied] = useState(false)
  const [isHoveringCopyButton, setIsHoveringCopyButton] = useState(false)

  const copySnippetToClipboard = async snippet => {
    await clipboardCopy(snippet)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 3000)
  }

  return (
    <TerminalWindowWrapper className="relative">
      <div
        className={`relative top left h-${height} w-full w-max-${width} b-r-16 overflow-hidden snippet-box`}
        style={{
          backgroundColor: `${theme === 0 ? "#061621" : "#FAFAFA"}`,
          boxShadow: "0 2px 10px 0 rgba(26,26,26,0.35)",
        }}
      >
        <div
          className="w-full fl fl-space-between white p-l-5"
          style={{
            background: `${theme === 0 ? "rgba(33, 49, 60, 0.5)" : "#E7EEEC"}`,
            height: "47px",
          }}
        >
          {languages.map((item, index) => {
            const active = language.name === item.name
            return (
              <div
                key={index}
                onClick={() => changeSelectedLanguage(item)}
                className="clickable txt-center p-5 fnt-menlo fnt-14"
                style={{
                  padding: "17px 10px",
                  lineHeight: "17px",
                  color:
                    theme === 0
                      ? active
                        ? "#9795F9"
                        : "#B8C4C2"
                      : active
                        ? "#09804C"
                        : "#5D6C74",
                }}
              >
                {item.name}
              </div>
            )
          })}
          <div
            className="p-h-15 p-v-10 relative"
            style={{ marginLeft: "auto" }}
          >
            <div
              className="txt-center fnt-menlo fnt-12"
              style={{
                padding: "0px 6px",
                background: `${copied ? "#0AD05B" : "#B8C4C2"}`,
                height: "24px",
                borderRadius: "12px",
                lineHeight: "26px",
                cursor: "pointer",
                color: "#21313C",
              }}
              onClick={() => {
                copySnippetToClipboard(codeSnippet)
              }}
              onMouseEnter={() => {
                setIsHoveringCopyButton(true)
              }}
              onMouseLeave={() => {
                setIsHoveringCopyButton(false)
              }}
            >
              <CopyIcon />
              {copied && <span className="m-l-5">Copied!</span>}
              {!copied && isHoveringCopyButton && (
                <span className="m-l-5">Copy</span>
              )}
            </div>
          </div>
        </div>
        <Content>{children}</Content>
      </div>
    </TerminalWindowWrapper>
  )
}
